import { HUB_CATEGORIES, eventCategoryForType } from "./constants.js";
import { sourceMeta } from "./feeds.js";

function listingExtras(sourceId, _slug, overrides = {}) {
  const source = sourceMeta(sourceId);
  return {
    source_id: sourceId,
    host: overrides.host || source?.name || "",
    url: overrides.url || "",
    address: overrides.address || source?.address || "",
    contact: overrides.contact || source?.contact || "",
    phone: overrides.phone || source?.phone || "",
  };
}

function prompt(category, suffix, body) {
  return {
    id: `th-prompt-${category}-${suffix}`,
    category,
    group_id: null,
    parent_id: null,
    kind: "prompt",
    body,
    author_id: "admin-dev",
    author_name: "REChecklist",
    author_role: "admin",
    created_at: "2026-08-30T15:00:00.000Z",
    pinned: true,
    hidden: false,
  };
}

const PROMPT_THREADS = HUB_CATEGORIES.filter((item) => item.id !== "special").flatMap((item) => [
  prompt(item.id, "attending", "Who is attending? Leave a short note if you plan to be there — helpful for others in this room."),
  prompt(item.id, "happening", "Is this still happening? If a time or room has changed, reply here so the hall stays kind and accurate."),
]);

function ev(id, title, type, rollOffsetDays, time, location, description, extra = {}) {
  return {
    id,
    title,
    type,
    category: extra.category || eventCategoryForType(type),
    date: extra.date || "",
    roll_offset: rollOffsetDays,
    time,
    location,
    address: extra.address || "",
    contact: extra.contact || "",
    phone: extra.phone || "",
    description,
    url: extra.url || "",
    host: extra.host || "",
    source_id: extra.source_id || "",
    thumbnail: extra.thumbnail || "",
    special: Boolean(extra.special),
    featured: Boolean(extra.featured),
    curated: true,
    rolling: extra.rolling !== false,
    group_id: extra.group_id || null,
    created_at: extra.created_at || "2026-08-31T12:00:00.000Z",
    hidden: false,
  };
}

export const SEED_HUB_EVENTS = [
  ev(
    "th-city-1",
    "La Jolla midweek mixer",
    "city",
    9,
    "8:00 AM",
    "La Jolla community room",
    "A calm city-level gathering for members. Education and introductions — not a race.",
    listingExtras("city-civic", "la-jolla-mixer", {
      address: "8100 La Jolla Shores Dr, La Jolla, CA 92037",
    })
  ),
  ev(
    "th-county-1",
    "San Diego County housing forum",
    "county",
    16,
    "9:30 AM",
    "County administration center",
    "County-level conversation on housing, held as a convenience listing for members.",
    listingExtras("county-civic", "housing-forum")
  ),
  ev(
    "th-state-1",
    "California association gathering",
    "state",
    6,
    "10:00 AM",
    "Sacramento convention hotel",
    "State-level gathering placeholder. Confirm hours on the host site before you travel.",
    listingExtras("state-assoc", "sacramento-gathering")
  ),
  ev(
    "th-nat-1",
    "National leadership week",
    "national",
    33,
    "9:00 AM",
    "National conference hotel",
    "National-level week for brokers and agents. Dates may shift; please verify with the host.",
    listingExtras("nat-assoc", "leadership-week")
  ),
  ev(
    "th-chamber-1",
    "Downtown chamber breakfast",
    "chamber",
    7,
    "7:30 AM",
    "Downtown chamber hall",
    "A local chamber breakfast. Guests welcome with a member.",
    listingExtras("chamber-downtown", "downtown-breakfast")
  ),
  ev(
    "th-gather-1",
    "Coastal major gathering",
    "gathering",
    0,
    "1:00 PM",
    "Waterfront pavilion",
    "A larger regional gathering for the professional community.",
    listingExtras("re-conf", "coastal-gathering", {
      address: "1375 Harbor Island Dr, San Diego, CA 92101",
    })
  ),
  ev(
    "th-con-1",
    "Pacific convention",
    "convention",
    14,
    "8:30 AM",
    "Convention center",
    "Convention listing for members. Not a REChecklist-hosted event.",
    listingExtras("conv-center", "pacific-convention")
  ),
  ev(
    "th-summit-1",
    "Broker culture summit",
    "summit",
    29,
    "9:00 AM",
    "National conference hotel",
    "A summit on office culture and retention. Broker-friendly seating.",
    listingExtras("hotel-cal", "broker-culture-summit")
  ),
  ev(
    "th-expo-1",
    "Regional housing expo",
    "expo",
    3,
    "10:00 AM",
    "Del Mar fairgrounds hall",
    "Education booths and industry exhibits. DreamHome is not a marketplace booth.",
    listingExtras("re-conf", "regional-housing-expo", {
      address: "2260 Jimmy Durante Blvd, Del Mar, CA 92014",
    })
  ),
  {
    id: "th-g-ev-1",
    title: "Coastal office huddle",
    type: "other",
    category: "associations",
    group_id: "th-g-coastal",
    date: "",
    roll_offset: 12,
    time: "8:15 AM",
    location: "Coastal conference room",
    address: "1200 Coast Hwy, Suite 400, Del Mar, CA 92014",
    contact: "Coastal Office · contact your broker of record",
    description: "A quiet weekly huddle for this brokerage circle only.",
    url: "",
    host: "Coastal Office",
    source_id: "",
    thumbnail: "",
    special: false,
    featured: false,
    curated: true,
    rolling: true,
    created_at: "2026-08-20T15:30:00.000Z",
    hidden: false,
  },
];

export const SEED_HUB_POSTS = [
  {
    id: "th-p1",
    category: "chat",
    group_id: null,
    parent_id: null,
    kind: "message",
    body: "Welcome to The Hub. This room is for brokers and agents only — a quiet place to share what is helping your desk this week.",
    author_id: "admin-dev",
    author_name: "REChecklist",
    author_role: "admin",
    created_at: "2026-08-28T16:00:00.000Z",
    pinned: true,
    hidden: false,
  },
  {
    id: "th-p2",
    category: "chat",
    group_id: null,
    parent_id: null,
    kind: "message",
    body: "If you are new, start with Broker / Agent Chat, then look for your city and county rooms. Client files stay on your Desk — they never mix in here.",
    author_id: "admin-dev",
    author_name: "REChecklist",
    author_role: "admin",
    created_at: "2026-08-28T16:08:00.000Z",
    pinned: false,
    hidden: false,
  },
  {
    id: "th-p3",
    category: "city",
    group_id: null,
    parent_id: null,
    kind: "message",
    body: "City rooms are for local cadence — breakfasts, mixers, and who is covering which neighborhood this month. Keep it kind and useful.",
    author_id: "admin-dev",
    author_name: "REChecklist",
    author_role: "admin",
    created_at: "2026-08-29T14:20:00.000Z",
    pinned: false,
    hidden: false,
  },
  {
    id: "th-p4",
    category: "associations",
    group_id: null,
    parent_id: null,
    kind: "message",
    body: "Association rooms are for brokerage circles. Brokers may open a circle for their office; agents join the circle that belongs to their broker.",
    author_id: "admin-dev",
    author_name: "REChecklist",
    author_role: "admin",
    created_at: "2026-08-29T15:00:00.000Z",
    pinned: true,
    hidden: false,
  },
  {
    id: "th-p5",
    category: "associations",
    group_id: "th-g-coastal",
    parent_id: null,
    kind: "announcement",
    body: "Coastal Office circle is open. Use this feed for office notes. Client files stay on the Desk.",
    author_id: "broker-demo",
    author_name: "Coastal Broker",
    author_role: "broker",
    created_at: "2026-08-29T16:00:00.000Z",
    pinned: true,
    hidden: false,
  },
  ...PROMPT_THREADS,
];

export const SEED_HUB_GROUPS = [
  {
    id: "th-g-coastal",
    name: "Coastal Office circle",
    summary: "A private circle for the coastal brokerage — chat, events, and announcements.",
    brokerage_id: "broker-demo",
    created_by: "broker-demo",
    created_at: "2026-08-20T15:00:00.000Z",
  },
];

export const SEED_HUB_MEMBERS = [
  { group_id: "th-g-coastal", user_id: "broker-demo", joined_at: "2026-08-20T15:00:00.000Z" },
  { group_id: "th-g-coastal", user_id: "agent-demo", joined_at: "2026-08-21T10:00:00.000Z" },
];
